import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ContentsKeyAssignments',
  data () {
    return {
      // テーブルオプション
      tableColumns: [
        'keyCode',
        'actionType',
        'parameter',
        'modifyButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          keyCode: 'キーコード',
          actionType: '動作',
          parameter: 'パラメータ',
          modifyButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          keyCode: 'wp-5',
          actionType: '',
          parameter: '',
          modifyButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'keyCode',
          'actionType',
          'parameter'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('キーアサイン設定'),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更・削除
      deleteTargetId: null,

      // input
      input: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,
      
      // modal
      updatedList: state => state.serviceContentsRegistKeyAssignModal.updated,
      keyAssignValue: state => state.serviceContentsRegistKeyAssignModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // validate
    formIsValid () {
      return true
    },

    // jsonb
    getJsonb () {
      return this.input.map(item => {
        const value = $.extend(true, {}, item)
        if (value.parameter === null) {
          delete value.parameter
        }
        return value
      })
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'contentsKeyAssignments',
          value: this.formIsValid
        })
      },
      deep: true
    },
    updatedList: function (to) {
      // モーダルでRSSの追加がされたらvalueを更新
      if (to) {
        const index = this.input.findIndex(item => item.keyCode === this.keyAssignValue.keyCode)
        if (index === -1) {
          this.input.push($.extend(true, {}, this.keyAssignValue))
        } else {
          this.$set(this.input, index, this.keyAssignValue)
        }
        // console.log(this.keyAssignValue)
      }
    },
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 削除
      if (this.confirmKey === 'delete') {
        to ?
          this.deleteData() :
          this.deleteTargetId = null
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      showServiceContentsRegistKeyAssignModal: 'serviceContentsRegistKeyAssignModal/show',
    }),
    ...mapMutations({
      setValidate: 'serviceContentsSettingForm/setValidate'
    }),

    init () {
      if (this.values.contentsKeyAssignments) {
        let data = $.extend(true, this.input, this.values.contentsKeyAssignments)
        this.$set(this, 'input', data)
        // this.tableData = $.extend(true, [], this.input)
      }
      this.tableData = this.input

      // 必須項目なし、もしくはラジオボタンのみの場合
      this.setValidate({
        key: 'contentsKeyAssignments',
        value: true
      })
    },

    // ファイル登録
    confirmData() {
      this.showConfirm({
        key: 'register',
        title: this.isRegister ?
          '' :
          '「keyCode : ' + this.modifyTargetId + '」の変更',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          'この' + this.categoryName + '情報を変更しますか？'
      })
    },
    deleteData () {
      let index = this.input.findIndex(item => item.keyCode === this.deleteTargetId)
      if (index !== -1) {
        this.input.splice(index, 1)
      }
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'keyCode':
          return Utility.getConstantsLabel(['ServiceContents', 'KeyCode'], value)
        case 'actionType':
          return Utility.getConstantsLabel(['ServiceContents', 'KeyActionType'], value)
        case 'parameter':
          return props.row.actionType === 1
            ? value.launchSpApp || value.action
            : props.row.actionType === 2
              ? value.webUrl
              : props.row.actionType === 3
                ? value.screenCode
                : ''
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      console.log('@@@@', this.serviceContentsId)
      this.showServiceContentsRegistKeyAssignModal({
        serviceId: this.serviceId,
        serviceContentsId: this.serviceContentsId,
        targetId: Constants.RegisterHash,
        data: this.input
      })
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.keyCode
      this.showServiceContentsRegistKeyAssignModal({
        serviceId: this.serviceId,
        serviceContentsId: this.serviceContentsId,
        targetId: this.modifyTargetId,
        data: this.input
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.keyCode
      const label = Utility.getConstantsLabel(['ServiceContents', 'KeyCode'], this.deleteTargetId)
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「' + label + '」を削除しますか？',
        acceptLabel: '削除'
      })
    },
  }
}
